angular.module(NgAppName).component("crSlide", {
	templateUrl: "crSlide.html",
	transclude: true,
	bindings: {
		speed: "<", // Animation speed
		missingUrl: "@", // Placeholder url
		nbInitialImagesLoaded: "@", // Number of images initially loaded
		hideEnlarge: "@", // Disable the fullscreen mode
		middleIndex: "@", // Use to position the highlighted thumbnail in the middle
		isThumbnails: "@", // Flag to know the slider contains thumbnails (and so depends from the main)
		crSlideMainName: "@",
		crSlideThumbnailName: "@",
		nbImagesToSlide: "@",
		slideSet: "@",
		sidebarSize: "<",
		isMoveToRight: "<",
		isFullWidth: "<",
		lazyLoad: '<',
		onMobile: "<",
		withDefaultImg: "<",
		marginLeftValue: "<",
		eventToCallOnImageClick: "@",
		eventToCallOnVideoClick: "@",
		rotate: "@",
		parent: "@",
		smallArrows: '@',
		hideArrows: "@",
		noImages: '@',
		isGuest: '<',
		isRegistrationRequired: '<',
		slideType: "@"
	},
	controller: ["$element", "$timeout", "$interval", "$compile", "$scope", "$window", "PubSub", function($element, $timeout, $interval, $compile, $scope, $window, PubSub) {
		var self = this;
		var w = angular.element($window);
		this.isLoaded = false;
		this.allLoaded = false;
		this.noEnlarge = typeof this.hideEnlarge !== 'undefined';
		this.thumbnailMode = typeof this.isThumbnails !== 'undefined';
		this.hideArrows = typeof this.hideArrows !== 'undefined';
		this.middleIndex = parseInt(this.middleIndex, 10) || 3;
		this.sidebarSize = parseInt(this.sidebarSize, 10) || 330;
		this.marginLeft = parseInt(this.marginLeftValue, 10) || 0;
		this.pageContentWrapper = angular.element(document.querySelector('.page_content_wrapper'));
		this.initialLoad = true;
		this.hasParentSpotlight = this.parent === 'spotlight' ? true : false;

		this.getSlideOffset = function(index) {
			var offset = 0;
			for (var i = 0; i < index; i++) {
				// offset += this.slides[i].width;
				offset += this.slides[i].getBoundingClientRect().width;
			}
			return offset;
		};

		this.showNext = function() {
			if (!this.animationIsDone) {
				return;
			}

			this.endOfSlider = this.isEndOfSlider(this.activeSlideIndex);

			// Rotate : go to the last one
			if (this.rotate && (this.endOfSlider || this.activeSlideIndex === this.slides.length - 1)) {
				this.activeSlideIndex = 0;
			} else {
			// Normal
				if (this.endOfSlider || this.activeSlideIndex === this.slides.length - 1) {
					return;
				}

				var nbImagesToSlide = this.nbImagesToSlide || 1;
				if (this.slideSet) {
					nbImagesToSlide = 0;
					var tmpWidth = 0;
					for (var i = this.activeSlideIndex; i < this.slides.length; i++) {
						tmpWidth += this.slides[i].getBoundingClientRect().width;
						if (tmpWidth <= this.wrapperWidth) {
							nbImagesToSlide++;
						} else {
							break;
						}
					}
				}

				this.activeSlideIndex += nbImagesToSlide;
				this.activeSlideIndex = Math.min(this.activeSlideIndex, this.slides.length - 1);
			}

			var pubName = this.thumbnailMode ? this.crSlideThumbnailName : this.crSlideMainName;
			PubSub.publish('crSlide-' + pubName + '-activeIndex', this.activeSlideIndex);
			this.showActiveSlideIndex(this.activeSlideIndex);

			// load the remaining images
			this.loadImageAndNextOnes(this.activeSlideIndex);
		};

		this.showPrevious = function() {
			if (!this.animationIsDone) {
				return;
			}

			// Rotate : go to the last one
			if (this.rotate && this.activeSlideIndex === 0) {
				this.activeSlideIndex = this.slides.length - 1;
			} else {
			// Normal
				if (this.activeSlideIndex === 0) {
					return;
				}

				var nbImagesToSlide = this.nbImagesToSlide || 1;
				if (this.slideSet) {
					nbImagesToSlide = 0;
					var tmpWidth = 0;
					for (var i = this.activeSlideIndex; i >= 0; i--) {
						// tmpWidth += this.slides[i].width;
						tmpWidth += this.slides[i].getBoundingClientRect().width;
						if (tmpWidth <= this.wrapperWidth) {
							nbImagesToSlide++;
						} else {
							break;
						}
					}
				}

				this.activeSlideIndex -= nbImagesToSlide;
				this.activeSlideIndex = Math.max(this.activeSlideIndex, 0);
			}


			var pubName = this.thumbnailMode ? this.crSlideThumbnailName : this.crSlideMainName;
			PubSub.publish('crSlide-' + pubName + '-activeIndex', this.activeSlideIndex);
			this.showActiveSlideIndex(this.activeSlideIndex);
		};

		this.isEndOfSlider = function(index) {
			var offset = this.getSlideOffset(index);
			// check if the offset + the wrapper width is superior to the container width
			// this.wrapperWidth = 315;
			if (typeof this.containerWidth === "undefined" && this.slideType === "building-gallery") {
				this.calculateContainerWidth();
			}

			if (offset + this.wrapperWidth > this.containerWidth) {
				return true;
			}

			return false;
		};

		this.showActiveSlideIndex = function(index, skipAnimation) {
			var speed = this.speed;
			if (this.isFullScreen || skipAnimation) {
				this.speed = 0;
			}

			this.animationIsDone = false;

			this.endOfSlider = this.isEndOfSlider(index);

			if (this.endOfSlider) {
				this.stripLeft = Math.min(0, self.wrapperWidth - self.containerWidth);
			} else {
				this.strip.removeClass('stick-to-end');
				var offset = this.getSlideOffset(index);
				this.stripLeft = -offset;
			}

			if (this.isFullScreen) {
				this.setFsImg(index);
			}

			// wait a little before restoring the default values
			$timeout(function() {
				self.animationIsDone = true;
				self.speed = speed;
			}, 100);
		};

		this.showFullScreen = function() {
			if (!this.fsElement) {
				this.setFsWrapper();
			}

			this.setFsImg(this.activeSlideIndex);
			this.isFullScreen = true;
		};


		this.setFsImg = function(index) {
			var slide = self.slides[index];
			this.fullScreenCurrentImage = slide.getAttribute('data-src-big');
		};

		this.setFsWrapper = function() {
			this.fsElement = $element[0].querySelector('.cr-slide-fs')
			angular.element(document.body).append(this.fsElement);
			this.fsImgContainer = angular.element(this.fsElement.querySelector('.cr-slide-fs-imgs .img-container'));
			this.fsFullScreenImg = angular.element(this.fsImgContainer[0].querySelector('.slide'));
			// this.fsFullScreenImg = this.fsImgContainer.find('img');

			// Add a callback to the image
			this.fsFullScreenImg.bind('load', this.imageLoaded);
			this.fsFullScreenImg.bind('error', function() {
				this.src = self.missingUrl;
			});
		};

		this.imageLoaded = function() {
			// get ratio to see if the image is wider or higher
			// if it is wider, set width to 100%
			// if it is higher, set heigh to 100%
			var xRatio = this.width / self.fsElement.getBoundingClientRect().width;
			var yRatio = this.height / self.fsElement.getBoundingClientRect().height;
			var format;
			if (xRatio >= yRatio) {
				format = 'wider';
			} else {
				format = 'higher';
			}

			$timeout(function() {
				self.fsImgClass = format;
			});
		};

		this.hideFullScreen = function() {
			this.isFullScreen = false;
		};

		this.loadImageAndNextOnes = function(index) {
			if (!self.allLoaded) {
				var indexImgMax = index + parseInt(this.nbInitialImagesLoaded, 10) - 1; // load some images in advance
				var limit = Math.min(this.slides.length - 1, indexImgMax);
				for (var i = index; i <= limit; i++) {
					if (!this.slides[i].loaded) {
						var urlSrc = this.slides[i].getAttribute('src');
						if (!urlSrc) {
							let iframe = this.slides[i].querySelector('iframe');
							// let images = this.slides[i].querySelectorAll('img[data-lazy-src]');

							let images = this.slides[i].tagName === 'IMG' ?  [this.slides[i]] : this.slides[i].querySelectorAll('img[data-lazy-src]');

							let iframeOrSlide = iframe || images; 

							if (iframeOrSlide) {
								if (iframe) { 
									this.cbImageLoaded(i);
								} else {
									for (let j = 0; j < images.length; j++) {
										let image = images[j];
										var urlSrc = image.getAttribute('data-lazy-src');
										image.setAttribute('src', urlSrc);
										image.removeAttribute('style');
									}
								} 
							}
						}
					}
				}
			}
		};

		this.getActiveSlideWidth = function(index) {
			var activeSlide = angular.element(self.wrapper.querySelectorAll('.slide')[index]);
			// var activeSlide = angular.element(self.wrapper).find('img')[index];
			return activeSlide.clientWidth;
		};

		this.calculateContainerWidth = function() {
			var containerWidth = 0;
			var images = angular.element(self.wrapper.querySelectorAll('.slide'));
			// var images = angular.element(self.wrapper).find('img');
			for (var i = 0; i < images.length; i++) {
				containerWidth += (Math.round(images[i].getBoundingClientRect().width * 100) / 100);
			}
			this.containerWidth = containerWidth;
		};

		this.cbImageLoaded = function(index) {
			// loaded to true for that image
			this.slides[index].loaded = true;

			// check if all images are loaded
			this.checkAllImagesAreLoaded();
		};


		this.moveOverlay = function(index) {
			this.overlayLeft = this.getSlideOffset(index);
			var paddingRight = (index === this.slides.length - 1 ? 0 : 5);
			this.overlayWidth = this.slides[index].getBoundingClientRect().width - paddingRight; // minus the padding 5px
		};

		this.cbTImageClicked = function(index) {
			// loaded to true for that image
			PubSub.publish('crSlide-' + this.crSlideThumbnailName, index);
			this.highlightedSlideIndex = index;

			this.moveOverlay(index); 
		};

		this.cbExtTActiveChanged = function(index) {
			this.highlightedSlideIndex = index;

			// calculate the active index
			// 0 <= activeIndex + 3 = highlightedIndex <= last possible active index before end of slide
			var newActiveSlideIndex = this.highlightedSlideIndex - this.middleIndex;
			while (this.isEndOfSlider(newActiveSlideIndex - 1) && newActiveSlideIndex > 0) {
				newActiveSlideIndex--;
			}
			if (newActiveSlideIndex < 0) {
				newActiveSlideIndex = 0;
			}
			this.activeSlideIndex = newActiveSlideIndex;

			this.showActiveSlideIndex(this.activeSlideIndex, true);
			// load the remaining images
			this.loadImageAndNextOnes(this.activeSlideIndex);

			this.moveOverlay(index);
		};

		this.cbExtMThumbnailClicked = function(index) {
			var indexSlideLoadedInAdvance = index + parseInt(self.nbInitialImagesLoaded, 10) - 1;

			// load the remaining images
			for (var i = this.activeSlideIndex; i <= index; i++) {
				this.loadImageAndNextOnes(i);
			}

			// check if all the previous images are loaded before setting the active slide
			var checkImagesLoaded = $interval(function() {
				var allLoaded = true;
				var limit = Math.min(self.slides.length - 1, indexSlideLoadedInAdvance);
				for (var i = 0; i <= limit; i++) {
					if (!self.slides[i].loaded) { 
						allLoaded = false;
						break;
					}
				}

				if (allLoaded) {
					$interval.cancel(checkImagesLoaded);
					checkImagesLoaded = undefined;
					self.activeSlideIndex = index;
					self.showActiveSlideIndex(self.activeSlideIndex, true);
				}
			}, 100);
		};

		this.checkAllImagesAreLoaded = function() {
			// check if all images are loaded
			var allLoaded = true;
			for (var i = 0; i < this.slides.length; i++) {
				if (!this.slides[i].loaded) {
					allLoaded = false;
					break;
				}
			}

			// remove crSlide hidden class once all initial images are loaded
			let loadedSlides = Object.values(this.slides).filter(s => {
				return s.loaded;
			});

			let maxInitialimages = Math.min(parseInt(self.nbInitialImagesLoaded, 10), this.slides.length);
			if (loadedSlides.length >= maxInitialimages) {
				$element[0].classList.remove('hidden');
			}


			// set the allLoaded variable
			this.allLoaded = allLoaded;

			// calculate final slider width
			if (this.allLoaded) {
				this.calculateContainerWidth();
				if (this.containerWidth < this.wrapperWidth) {
					this.endOfSlider = true;
				}
			}
		};

		this.imageClick = function(index, isIFrame) {
			if (this.isGuest && this.isRegistrationRequired) {
				PubSub.publish('cr-popup-open-');
			} else {
				if (isIFrame && this.eventToCallOnVideoClick) {
					PubSub.publish(this.eventToCallOnVideoClick, index);
				} else if (this.eventToCallOnImageClick) {
					PubSub.publish(this.eventToCallOnImageClick, index);
				}
			}
		};

		
		this.init = function() {
			this.isLoaded = true;
			$element.removeClass('loading');
			this.wrapper = $element[0].querySelector('.cr-slide-wrapper');
			this.strip = angular.element(this.wrapper.querySelector('.cr-slide-strip'));

			this.slides = angular.element(this.wrapper.querySelectorAll('.slide'));

			// this.slides = angular.element(this.wrapper).find('img');
			var lastSlide = angular.element(this.slides[this.slides.length - 1]);
			var placeholderAttr = lastSlide.length ? lastSlide[0].attributes['data-is-placeholder'] : '';
			// check if the last image is a placeholder (to fill the empty space)
			if (this.slides.length === 0 || (placeholderAttr && placeholderAttr.value === "1") /*|| this.onMobile*/) {
				this.showArrows = false;
			} else {
				if (!this.hideArrows) {
					this.showArrows = true;
				}
			}

			this.wrapperWidth = this.isFullWidth ? document.body.clientWidth : this.wrapper.clientWidth;
			this.stripLeft = 0;
			this.activeSlideIndex = 0;

			this.highlightedSlideIndex = 0;
			if (this.slides.length) {
				this.moveOverlay(this.highlightedSlideIndex);
			}

			this.deviation = 0;
			this.animationIsDone = true;
			this.isFullScreen = false;

			if (this.noImages) {
				this.calculateContainerWidth();
				if (this.containerWidth < this.wrapperWidth) {
					this.endOfSlider = true;
				}
			}

			// define callback for image load
			let slides = this.slides;

			for (var i = 0; i < slides.length; i++) {
				let dataImageIndex = slides[i].getAttribute("data-image-index");
				let ind = dataImageIndex ? parseInt(dataImageIndex, 10) : i;
				let iframe = slides[i].querySelector('iframe');
				let isIframe = iframe ? true : false;

				if (iframe) {
					if (i < parseInt(self.nbInitialImagesLoaded, 10)) {
						self.cbImageLoaded(i);
					}
				} else {
					if (i < parseInt(self.nbInitialImagesLoaded, 10)) {
						self.cbImageLoaded(i);
					} else {
						let slide = slides[i].tagName === 'IMG' ?  slides[i] : slides[i].querySelector('img');
						angular.element(slide).bind("load", (function(index) {
							return function() {
								self.cbImageLoaded(index);
							};
						}(i)));
					}
				}
			}

			// define callback for clickable images
			let slidesFirst = angular.element(this.wrapper.querySelectorAll('.slide:not(.slide-not-clickable):not(.no-popup)'));
			let slidesSecond = angular.element(this.wrapper.querySelectorAll('.slide-clickable')); 
			let slidesClickable = [...slidesFirst, ...slidesSecond];

			for (var i = 0; i < slidesClickable.length; i++) {
				let dataImageIndex = slidesClickable[i].getAttribute("data-image-index");
				let ind = dataImageIndex ? parseInt(dataImageIndex, 10) : i;
				let iframe = slidesClickable[i].querySelector('iframe');
				let isIframe = iframe ? true : false;

				// bind click on images
				if ((this.thumbnailMode || this.eventToCallOnImageClick) && !angular.element(slidesClickable[i]).hasClass("no-popup")) {
					angular.element(slidesClickable[i]).bind('click', (function(index, isIframe) {
						return function() {
							console.log('click slide => ' + index);
							if (self.thumbnailMode) {
								self.cbTImageClicked(index);
							} else {
								self.imageClick(index, isIframe);
							}
						};
					}(ind, isIframe)));
				}
			}


			// Subscribe to events
			if (this.thumbnailMode) {
				PubSub.subscribe('crSlide-' + this.crSlideMainName + '-activeIndex', this.cbExtTActiveChanged.bind(this));
			} else {
				PubSub.subscribe('crSlide-' + this.crSlideThumbnailName, this.cbExtMThumbnailClicked.bind(this));
			}
		};

		w.bind('resize', function() {
			if (self.wrapper) {
				self.marginLeft = 0;
				self.wrapperWidth = self.wrapper.clientWidth ;
				self.endOfSlider = self.isEndOfSlider(self.activeSlideIndex);

				if (self.endOfSlider && self.wrapperWidth < self.containerWidth && self.activeSlideIndex !== 0) {
					self.strip.addClass('stick-to-end');

					$timeout(function() {
						self.stripLeft = Math.min(0, self.wrapperWidth - self.containerWidth);
					}, 50);
				} else {
					self.strip.removeClass('stick-to-end');
				}
			}
		});

		this.$postLink = function () {
			if (this.lazyLoad) {
				// load the visible sliders on load
				$timeout(() => {
					if ($element[0].getBoundingClientRect().y - window.getHeight() < 100 && !this.isLoaded) {
						let slides = $element[0].querySelectorAll('img');
						for (let i = 0; i < slides.length; i++) {
							let imgSrc = slides[i].getAttribute('data-src-normal');
							if (imgSrc) {
								slides[i].setAttribute('src', imgSrc);
							}
						}

						this.init();
					}
				});

				// load the sliders on scroll
				w.bind("scroll", (e) => {

					if ($element[0].getBoundingClientRect().y - window.getHeight() < 100 && !this.isLoaded) {
						let slides = $element[0].querySelectorAll('img');
						for (let i = 0; i < slides.length; i++) {
							let imgSrc = slides[i].getAttribute('data-src-normal');
							if (imgSrc) {
								slides[i].setAttribute('src', imgSrc);
							}
						}

						$timeout(() => {
							this.init();
						});
					}
				});
			} else {
				$timeout(() => {
					this.init();
				});
			}

	 	};
	}]
});